<template>
  <div class="form-enrolment mx-auto my-10">
    <ValidationObserver
      ref="observer"
      v-slot="{ invalid }"
    >
      <form @submit.prevent="onSubmit">
        <ValidationProvider v-if="isNew" name="course" rules="required" v-slot="{ errors }">
          <v-select
            v-model="enrolment.course"
            :error-messages="errors"
            :items="courses"
            item-text="name"
            item-value="id"
            label="Curso"
            filled
            required
          ></v-select>
        </ValidationProvider>
        <ValidationProvider name="type" rules="required" v-slot="{ errors }">
          <v-select
            v-model="enrolment.type"
            :error-messages="errors"
            :items="types"
            item-text="text"
            item-value="value"
            label="Tipo"
            filled
            required
          ></v-select>
        </ValidationProvider>
        <ValidationProvider name="limitAccess" rules="required" v-slot="{ errors }">
          <v-menu
            ref="datePicker"
            v-model="datePicker"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="enrolment.limitAccess"
                :error-messages="errors"
                label="Limite de acesso"
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="enrolment.limitAccess"
              no-title
              @input="datePicker = false"
            ></v-date-picker>
          </v-menu>
        </ValidationProvider>

        <v-divider class="my-5"></v-divider>

        <v-btn
          block
          rounded
          large
          class="my-2"
          type="submit"
          color="primary"
          :disabled="invalid"
        >
          {{ isNew ? 'Criar' : 'Editar' }}
        </v-btn>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import AdminCourseService from '@/services/admin-course/admin-course.service';
import Enrolment from '@/models/enrolment';

const courseService = new AdminCourseService();

export default {
  name: 'FormEnrolment',
  emits: ['submitEnrolment'],
  props: {
    isNew: Boolean,
    enrolment: Enrolment,
  },
  data: () => ({
    types: [
      {
        text: 'Normal (Máquinas são removidas)',
        value: 'regular',
      },
      {
        text: 'Ilimitado (Máquina não são removidas)',
        value: 'unlimited',
      },
    ],
    courses: [],
    datePicker: false,
  }),
  mounted() {
    courseService.getCourses()
      .then((response) => this.courses = response.data)
      .catch(console.error);
  },
  methods: {
    onSubmit() {
      this.$refs.observer.validate();

      this.$emit('submitEnrolment', this.enrolment);
    }
  },
};
</script>

<style scoped>
.form-enrolment {
  max-width: 50%;
}
</style>
